import { jsx as _jsx } from "react/jsx-runtime";
import { formatVerboseHms, parseHmsString } from "../../components/utils/formatTime";
import { resolveRouteSpeed, routeSpeedTextClass } from "../../lib/routeSpeed";
import { cn } from "../../components/utils/cn";
/** Renders the verbose estimate; slow routes are yellow and very slow routes red (see `routeSpeed.ts`). */
const AverageCompletionTime = ({ avgCompletionTime, className }) => {
    const parts = parseHmsString(avgCompletionTime);
    if (!parts)
        return;
    const speed = resolveRouteSpeed(avgCompletionTime);
    return _jsx("p", { className: cn(className, routeSpeedTextClass(speed, '')), children: formatVerboseHms(parts) });
};
export default AverageCompletionTime;
